import {
    requestAllSignoffs,
    requestSaveSignoff,
    requestDeleteSignoff
} from "@/api/signoff-api";

const actions = {

    async getAllSignoffs({commit}, data) {
        let result = await requestAllSignoffs(data)
        if (result.code === '200') {
            return result
        } else {
            return Promise.reject(new Error('無法取得資料'))
        }
    },

    async saveSignoff({commit}, data) {
        let result = await requestSaveSignoff(data)
        if (result.code === '200') {
            return result.message
        } else {
            return Promise.reject(new Error('資料更新失敗'))
        }
    },

    async deleteSignoff({commit}, data) {
        let result = await requestDeleteSignoff(data)
        if (result.code === '200') {
            return result.message
        } else {
            return Promise.reject(new Error('資料刪除失敗'))
        }
    }
}

const mutations = {}
const state = {}

const getters = {}

export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters
}
